import React from 'react';

import Spacer from './Spacer';

const VerticalSpacer = () => <Spacer my={2} />;

export default VerticalSpacer;
